import api from 'api';
import DesignTemplate from 'records/DesignTemplate';

export const UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const UPCOMING_OCCA_DESIGN_TEMPLATES_RESET_STATE = 'UPCOMING_OCCA_DESIGN_TEMPLATES_RESET_STATE';

function upcomingOccaDesignTemplatesAsyncActionStart() {
  return {
    type: UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function upcomingOccaDesignTemplatesAsyncActionError(error) {
  return {
    type: UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function upcomingOccaDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetupcomingOccaDesignTemplatesState() {
  return {
    type: UPCOMING_OCCA_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getupcomingOccaDesignTemplates(designTypeId, designSizeId, currentDate, layoutId ) {
  return (dispatch, getState) => {
    dispatch(upcomingOccaDesignTemplatesAsyncActionStart());
    return api.request(
      `theme/list?date=${ currentDate }&isOccasion=true&designtid=${ designTypeId }&sizeid=${ designSizeId }&sendDesTem=true&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(upcomingOccaDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(upcomingOccaDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getupcomingOccaThemeDesignTemplates(currentDate,layoutId ) {
  return (dispatch, getState) => {
    dispatch(upcomingOccaDesignTemplatesAsyncActionStart());
    return api.request(
      `theme/list?date=${ currentDate }&isOccasion=true&sendDesTem=true&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(upcomingOccaDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(upcomingOccaDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function filterupcomingOccaDesignTemplates(designTypeId, designSizeId, currentDate, layoutId) {
  return (dispatch, getState) => {
    dispatch(upcomingOccaDesignTemplatesAsyncActionStart());
    let tmpDesignData = getState().upcomingOccaDesignTemplates.get('data');
    let filterData = DesignTemplate.getDesignTemplatesByTypeAndSizeId(tmpDesignData, designTypeId, designSizeId);

    let filterLayoutData = filterData;
    if(layoutId!=undefined){
     filterLayoutData=DesignTemplate.getDesignTemplatesByLayoutId(filterData, layoutId);
   }

    if(filterLayoutData.size == 0){
      dispatch(getupcomingOccaDesignTemplates(designTypeId, designSizeId, currentDate, layoutId));
    } else {
      dispatch(resetupcomingOccaDesignTemplatesState());
      dispatch(upcomingOccaDesignTemplatesAsyncActionSuccess(filterLayoutData));
    }
  };
}
